// https://github.com/vercel/next.js/pull/15772#discussion_r463984612
import 'core-js/features/object/from-entries';
import ResizeObserver from 'resize-observer-polyfill';
if(typeof window !== 'undefined' && !window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}